<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="" prop="status">
                <el-radio-group v-model="query.dataRange">
                    <el-radio-button :label="7">近7天</el-radio-button>
                    <el-radio-button :label="30">近30天</el-radio-button>
                    <el-radio-button :label="90">近90天</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开始时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.begin_date"
                    type="date"
                    size="mini"
                    placeholder="选择开始时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.end_date"
                    type="date"
                    size="mini"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>

            <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
        </el-form>
        <el-table :loading="loading" :data="flatTableData" :height="tableHeight" size="mini" ref="multipleTable"
                  :span-method="mergePersonCells" class="table_content mini_div selectionStatisticsTable"
                  style="width: 100%;" :cell-style="cellStyle">

            <!-- 人员 -->
            <el-table-column prop="full_name" label="人员" width="100" align="center"/>

            <!-- 选品列表 -->
            <el-table-column label="选品列表" align="center">
                <el-table-column label="合计" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'buyingTotal')"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="countryName" label="国家" width="80" align="center"/>
                <el-table-column label="数量" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'selection_all')"></div>
                    </template>
                </el-table-column>
                <el-table-column label="完成价格和销售核对" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'selection_has_collate')"></div>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 采购中 -->
            <el-table-column label="采购中" align="center">
                <el-table-column label="合计" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'buyingTotal1')"></div>
                    </template>
                </el-table-column>

                <el-table-column prop="countryName" label="国家" width="80" align="center"/>
                <el-table-column label="数量" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchasing_all')"></div>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 采购完成 -->
            <el-table-column label="采购完成" align="center">
                <el-table-column label="合计" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'completeTotal')"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="countryName" label="国家" width="80" align="center"/>
                <el-table-column label="数量" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchased_all')"></div>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 符合通配要求 -->
            <el-table-column label="符合利润要求" align="center">
                <el-table-column label="已分配运营" width="120" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchased_user_y_profit_y')"></div>
                    </template>
                </el-table-column>

                <el-table-column label="未分配送营" width="120" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchased_user_n_profit_y')"></div>
                    </template>
                </el-table-column>
            </el-table-column>

            <!-- 不符合通配要求 -->
            <el-table-column label="不符合利润要求" align="center">
                <el-table-column label="已分配运营" width="120" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchased_user_y_profit_n')"></div>
                    </template>
                </el-table-column>

                <el-table-column label="未分配运营" width="120" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'purchased_user_n_profit_n')"></div>
                    </template>
                </el-table-column>
            </el-table-column>


            <!-- 忽略列表 -->
            <el-table-column label="忽略列表" align="center">
                <el-table-column label="合计" width="110" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'total')"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="countryName" label="国家" width="80" align="center"/>
                <el-table-column label="数量" width="120" align="center">
                    <template slot-scope="scope" align="center">
                        <div v-html="getDiffDom(scope.row, 'ignore_all')"></div>
                    </template>
                </el-table-column>
                <el-table-column label="同款已分析" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'ignore_hadused')"></div>
                    </template>
                </el-table-column>
                <el-table-column label="找不到同款" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'ignore_notfound')"></div>
                    </template>
                </el-table-column>
                <el-table-column label="利润不符" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'ignore_errprofit')"></div>
                    </template>
                </el-table-column>
                <el-table-column label="其他" width="100" align="center">
                    <template slot-scope="scope">
                        <div v-html="getDiffDom(scope.row, 'ignore_other')"></div>
                    </template>
                </el-table-column>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px; display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'

export default {
    name: 'categoryStatistics',
    computed: {
        // 扁平化数据结构，方便合并单元格
        flatTableData() {
            const result = []
            this.mergeMap = {} // 记录每个人需要合并几行
            this.list.forEach((person) => {
                this.mergeMap[person.full_name] = person.items.length
                person.items.forEach((item, idx) => {
                    result.push({
                        ...item,
                        full_name: idx === 0 ? person.full_name : '',
                        total: idx === 0 ? person.total : '',
                        buyingTotal: idx === 0 ? person.buyingTotal : '',
                        buyingTotal1: idx === 0 ? person.buyingTotal1 : '',
                        completeTotal: idx === 0 ? person.completeTotal : '',
                        begin_total: idx === 0 ? person.begin_total : '',
                        begin_buyingTotal: idx === 0 ? person.begin_buyingTotal : '',
                        begin_buyingTotal1: idx === 0 ? person.begin_buyingTotal1 : '',
                        begin_completeTotal: idx === 0 ? person.begin_completeTotal : '',
                    })
                })
            })
            return result
        },
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        'query.dataRange': {
            handler(value) {
                value = value - 1
                this.query.begin_date = new Date(Date.now() - value * 24 * 60 * 60 * 1000)
                this.query.end_date = new Date()
                this.getList()
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            countryObj: {
                de: '德国',
                us: '美国',
                fr: '法国',
                uk: '英国',
            },
            categoryList: [],
            peopleListVisible: false,
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            query: {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                category_state: '',
                category_id: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    methods: {
        cellStyle({ columnIndex }) {
            // 设置每组的颜色
            const groupColors = {
                A: '#ede7f6',
                B: '#e3f2fd',
                C: '#e8f5e9',
                D: '#fff3e0',
                E: '#f3e5f5',
                F: '#fce4ec'
            };

            const groupMap = {
                A: [1, 2, 3, 4],
                B: [5, 6, 7],
                C: [8, 9, 10],
                D: [11, 12],
                E: [13, 14],
                F: [15, 16, 17, 18, 19, 20, 21]
            };

            for (const [group, indices] of Object.entries(groupMap)) {
                if (indices.includes(columnIndex)) {
                    return { backgroundColor: groupColors[group] };
                }
            }

            return {}; // 默认不变
        },
        getDiffDom(data, key) {
            const num = (data[key] || 0) - (data['begin_' + key] || 0)
            const colorStr = num > 0 ? 'green' : num < 0 ? 'red' : ''
            const arrow = num > 0 ? '↑' : num < 0 ? '↓' : ''
            const style = `color: ${colorStr}; font-weight: bold;`
            const appendStr = num !== 0 ? `(${arrow}${Math.abs(num)})` : ''
            return `<span style="${style}">${data[key]}${appendStr}</span>`
        },
        mergePersonCells({rowIndex, columnIndex}) {
            // 需要合并的列：人员、合计、采购中合计、采购完成合计
            const colsToMerge = [0, 1, 5, 8, 15]
            if (!colsToMerge.includes(columnIndex)) return

            const row = this.flatTableData[rowIndex]
            if (!row.full_name) {
                return {rowspan: 0, colspan: 0}
            }

            const rowspan = this.mergeMap[row.full_name]
            return {rowspan, colspan: 1,}
        },
        getNumDiff(obj, variableStr, preStr) {
            let res = {flag: false, num: 0}
            if (obj.begin_date_datas && obj.end_date_datas) {
                res = {flag: true, num: obj.end_date_datas[variableStr] - obj.begin_date_datas[variableStr]}
            }
            return res
        },

        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getList() {
            this.loading = true
            let tempQuery = JSON.parse(JSON.stringify(this.query))
            tempQuery.begin_date = this.formatDate(new Date(tempQuery.begin_date))
            tempQuery.end_date = this.formatDate(new Date(tempQuery.end_date))
            api.manager_statistics_statistics_developer(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    let responseList = (res.data.list || []).map(item => {
                        item.items = []
                        item.begin_total = 0
                        item.begin_buyingTotal = 0
                        item.begin_buyingTotal1 = 0
                        item.begin_completeTotal = 0
                        item.total = 0
                        item.buyingTotal = 0
                        item.buyingTotal1 = 0
                        item.completeTotal = 0
                        const endKeys = Object.keys(item.end_date_datas || {})

                        for (const keyItem of endKeys) {
                            let obj = {}
                            obj.country = keyItem
                            obj.countryName = this.countryObj[keyItem] || ''
                            const content = item.end_date_datas[keyItem]
                            Object.assign(obj, content)

                            const beginObj = item.begin_date_datas[keyItem]
                            for (const beginKey in beginObj) {
                                obj['begin_' + beginKey] = beginObj[beginKey]
                            }

                            item.items.push(obj)
                            item.begin_total += beginObj.ignore_all || 0
                            item.begin_buyingTotal += beginObj.selection_all || 0
                            item.begin_buyingTotal1 += beginObj.purchasing_all || 0
                            item.begin_completeTotal += beginObj.purchased_all || 0
                            item.total += content.ignore_all || 0
                            item.buyingTotal += content.selection_all || 0
                            item.buyingTotal1 += content.purchasing_all || 0
                            item.completeTotal += content.purchased_all || 0
                        }
                        return item
                    })
                    responseList = responseList.sort((a, b)=>b.buyingTotal-a.buyingTotal)
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        formatDate(date) {
            const yyyy = date.getFullYear()
            const mm = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
            const dd = String(date.getDate()).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                category_state: '',
                category_id: '',
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        onBatchDistribution() {
            if (this.multipleSelection.length > 0) {
                this.peopleListVisible = true
            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },

        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        // 关闭弹窗回调
        chooseDevelopCloseCallback(arr) {
            this.peopleListVisible = false
            if (arr.length > 0) {
                api.manager_cost_analysis_manager_batch_distribution({
                    ids: this.multipleSelection,
                    developer_id: arr[0]
                }).then(res => {
                    if (res.code === 0) {
                        this.$message.success('分配成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }
        },
        refreshList() {
            this.getList()
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.greenTxt {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}

</style>
